import { useState, useEffect } from "react";
import { getVideos } from "../services/youtube";
import VideoCard from "../components/VideoCard";

export default function VideoGallery() {

  const [videos, setVideos] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getVideos().then((data) => {
      setVideos(data);
    });
  }, []);

  const filteredVideos = videos.filter((video) =>
    video.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div
      style={{
        maxWidth: "1300px",
        margin: "40px auto",
        padding: "20px",
      }}
    >
      {/* Title */}
      <h1
        style={{
          textAlign: "center",
          color: "#ffffff",
          marginBottom: "30px",
          fontSize: "36px",
          fontWeight: "bold",
        }}
      >
         K-Mech Edunet Video Gallery
      </h1>

      {/* Search Bar */}
      <input
        type="text"
        placeholder="🔍 Search educational videos..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{
          width: "100%",
          padding: "15px",
          fontSize: "16px",
          borderRadius: "30px",
          border: "none",
          outline: "none",
          marginBottom: "30px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
        }}
      />

      {/* Video Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "25px",
        }}
      >
        {filteredVideos.length > 0 ? (
          filteredVideos.map((video) => (
            <VideoCard
              key={video.id}
              video={video}
            />
          ))
        ) : (
          <div
            style={{
              color: "#fff",
              fontSize: "18px",
              textAlign: "center",
              gridColumn: "1 / -1",
            }}
          >
            No videos found.
          </div>
        )}
      </div>
    </div>
  );
}